import gql from 'graphql-tag';

export const NOTIFICATION_SETTING_FRAGMENT = gql`
  fragment NotificationSettingFragment on NotificationSetting {
    social_post
    message_digest
  }
`;
